import React, { PropTypes } from 'react';
import Dropdown from 'common/components/Dropdown';
import { staticIconUrl } from '../../reducers/point';

const SHAPES = [
  {
    code: 'circle',
    icon: 'rond',
    label: 'Rond',
  },
  {
    code: 'square',
    icon: 'carre',
    label: 'Carré',
  },
  {
    code: 'diamond',
    icon: 'losange',
    label: 'Losange',
  },
  {
    code: 'hexagon',
    icon: 'hexagone',
    label: 'Hexagone',
  },
  {
    code: 'crest',
    icon: 'crest',
    label: 'Écusson',
  },
  {
    code: 'trapeze',
    icon: 'trapeze',
    label: 'Trapèze',
  },
];

const renderDefault = () => (
  <div className="default text">Forme géométrique</div>
);

const renderItem = item => (
  <div key={item.code} data-value={item.code} className="item">
    <img
      src={staticIconUrl(item.icon)}
      alt="Forme géométrique"
      style={{ marginTop: '0px' }}
    />
    {item.label}
  </div>
);

const PointForm = ({ point, disabled }) => (
  <form className="ui form">
    <div className="ui fields">
      <div className="eight wide field">
        <label>Numéro</label>
        <input
          name="number"
          type="number"
          readOnly
          defaultValue={point.number}
        />
      </div>
      <div className="eight wide field">
        <label>Nom</label>
        <input
          name="name"
          type="text"
          defaultValue={point.name}
          readOnly={disabled}
        />
      </div>
    </div>
    <div className="ui field">
      <label>Forme géométrique</label>
      <Dropdown
        name="shape"
        value={point.shape}
        items={SHAPES}
        renderDefault={renderDefault}
        renderItem={renderItem}
        disabled={disabled}
      />
    </div>
  </form>
);

PointForm.propTypes = {
  point: PropTypes.object.isRequired,
};

export default PointForm;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/components/forms/PointForm.js